/* Passion Bake — AOS bootstrap
 * Auto-applies data-aos="fade-up" to every .shopify-section (except chrome)
 * and initializes AOS with the same config as the live Andaman theme:
 * offset: 0, delay: 0, duration: 600. */
(function () {
  'use strict';

  if (window.__pbAosInit) return;
  window.__pbAosInit = true;

  var SKIP_KEYWORDS = [
    'header', 'announcement', 'footer', 'cart-drawer', 'predictive-search',
    'search-drawer', 'menu-drawer', 'popup', 'gift_card', 'sticky',
    'password', 'localization'
  ];

  function shouldSkip(section) {
    var id = (section.id || '').toLowerCase();
    var classes = (section.className || '').toLowerCase();
    for (var i = 0; i < SKIP_KEYWORDS.length; i++) {
      if (id.indexOf(SKIP_KEYWORDS[i]) !== -1) return true;
      if (classes.indexOf(SKIP_KEYWORDS[i]) !== -1) return true;
    }
    return false;
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function applyAos(root) {
    var scope = root || document;
    scope.querySelectorAll('.shopify-section').forEach(function (section) {
      if (shouldSkip(section)) return;
      if (section.hasAttribute('data-aos')) return;
      section.setAttribute('data-aos', 'fade-up');
      section.setAttribute('data-aos-duration', '600');
      section.setAttribute('data-aos-easing', 'ease-out-cubic');
    });
  }

  function initAos() {
    if (reduceMotion()) {
      document.querySelectorAll('[data-aos]').forEach(function (el) {
        el.removeAttribute('data-aos');
      });
      return;
    }
    if (typeof AOS !== 'undefined' && typeof AOS.init === 'function') {
      AOS.init({
        offset: 0,
        delay: 0,
        duration: 600,
        easing: 'ease-out-cubic',
        once: true,
        mirror: false,
        disable: false
      });
    }
  }

  function refresh() {
    if (typeof AOS !== 'undefined' && typeof AOS.refresh === 'function') {
      AOS.refresh();
    }
  }

  function boot() {
    applyAos();
    initAos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on theme editor section reloads
  document.addEventListener('shopify:section:load', function (e) {
    applyAos(e.target);
    refresh();
  });
  document.addEventListener('shopify:section:reorder', refresh);
  document.addEventListener('shopify:section:select', refresh);

  // Safety: ensure AOS sees everything once page is fully loaded
  window.addEventListener('load', function () {
    setTimeout(refresh, 120);
  });
})();
